import type { ReactNode } from "react";
import { classNames } from "../styles/classNames";

interface OptionLabelProps {
  /** `start` for an option whose text runs over several lines. */
  align?: "center" | "start";
  /** `small` inside dense rows such as a table cell or a step card. */
  size?: "regular" | "small";
  className?: string;
  /** The checkbox or radio button first, then its text. */
  children: ReactNode;
}

/** A checkbox or radio button with its text; clicking the text toggles it. */
export default function OptionLabel({ align = "center", size = "regular", className, children }: OptionLabelProps) {
  return (
    <label
      className={classNames(
        "app-text flex gap-2",
        align === "center" ? "items-center" : "items-start",
        size === "regular" ? "text-sm" : "text-xs",
        className,
      )}
    >
      {children}
    </label>
  );
}
